import React from 'react'
import styled from '@emotion/styled'
import { useBillingSettingsPageBusinessLogic } from '../../../logic/context'

const BillingSettingsHeaderControlsLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
`

export const BillingHeaderControls = () => {
    const pageLogic = useBillingSettingsPageBusinessLogic()

    return (
        <BillingSettingsHeaderControlsLayout>
            {/* Header controls for Billing Settings page */}
        </BillingSettingsHeaderControlsLayout>
    )
}

